/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { GET_DELIVERY_RECEIPT } from "../graphql/getDeliveryReceipt.query";

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IgetDeliveryReceiptTypeMethods extends IPluginMethodMap {
  getDeliveryReceipt(args: any): Promise<any>;
}

export class getDeliveryReceiptService implements IAgentPlugin {
  readonly methods: IgetDeliveryReceiptTypeMethods;

  constructor() {
    this.methods = {
      getDeliveryReceipt: this.getDeliveryReceipt.bind(this),
    };
  }

  async getDeliveryReceipt(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    console.log("costumeId", args);
    const boxFilter =
      args?.prevPage !== "DeliveredReport"
        ? args?.isCostumeId
          ? {
              costumeID: args?.id,
            }
          : {
              _id: args?.id,
            }
        : {
            costumeID: args?.costumeId,
          };
    try {
      if (client) {
        const res = await client.query({
          query: GET_DELIVERY_RECEIPT,
          variables: {
            filter: boxFilter,
          },
          fetchPolicy: "network-only",
        });

        if (
          res?.data?.getDeliveredPDF?.pdf &&
          is.existy(res?.data?.getDeliveredPDF?.pdf)
        ) {
          return res?.data?.getDeliveredPDF?.pdf;
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}
